import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { API } from '../constants/api.constants';

@Injectable()
export class AccountService  {
    constructor(private http: Http) { }

    // get(): Observable<any> {
    //     return this.http.get(API.profile).map((res: Response) => res.json());
    // }

    // save(account: any): Observable<Response> {
    //     return this.http.post(API.profile, account);
    // }
}
